import React, { Dispatch, SetStateAction } from 'react';
import { AlertColor } from '@mui/material';

interface SnackBarContextInterface {
  showInvalidFormatSnackBar?: (message: string) => Promise<void>;
  showInfoSnackBar?: (message: string) => Promise<void>;
  showErrorSnackBar?: (message: string) => Promise<void>;
  showSuccessSnackBar?: (message: string) => Promise<void>;
  setSnackBarOpen?: Dispatch<SetStateAction<boolean>>;
  snackBarOpen?: boolean;
  setSnackBarMessage?: Dispatch<SetStateAction<string>>;
  snackBarMessage?: string;
  handleSnackbarAlertSeverityChange?: any;
  snackbarAlertSeverity?: any;
}

interface SnackBarContextProviderProps {
  children: React.ReactNode;
}

const SnackBarContext = React.createContext<SnackBarContextInterface>({});

const SnackBarContextConsumer = SnackBarContext.Consumer;
const SnackBarContextProvider: React.FC<SnackBarContextProviderProps> = ({ children }) => {
  const [snackBarOpen, setSnackBarOpen] = React.useState<any>(false);
  const [snackBarMessage, setSnackBarMessage] = React.useState<any>('');
  const [snackbarAlertSeverity, setSnackbarAlertSeverity] = React.useState<AlertColor>('success');

  const handleSnackbarAlertSeverityChange = (status) => {
    if (status.toLocaleLowerCase() === 'success') {
      setSnackbarAlertSeverity('success');
    }
    if (status.toLocaleLowerCase() === 'error') {
      setSnackbarAlertSeverity('error');
    }
    if (status.toLocaleLowerCase() === 'info') {
      setSnackbarAlertSeverity('info');
    }
    if (status.toLocaleLowerCase() === 'warning') {
      setSnackbarAlertSeverity('warning');
    }
  };

  const showSuccessSnackBar = async (message: string) => {
    setSnackBarOpen(true);
    setSnackBarMessage(message);
    handleSnackbarAlertSeverityChange('success');
  };

  const showErrorSnackBar = async (message: string) => {
    setSnackBarOpen(true);
    setSnackBarMessage(message);
    handleSnackbarAlertSeverityChange('error');
  };

  const showInvalidFormatSnackBar = async (message: string) => {
    setSnackBarOpen(true);
    setSnackBarMessage(message);
    handleSnackbarAlertSeverityChange('error');
  };

  const showInfoSnackBar = async (message: string) => {
    setSnackBarOpen(true);
    setSnackBarMessage(message);
    handleSnackbarAlertSeverityChange('info');
  };

  return (
    <SnackBarContext.Provider
      value={{
        showInvalidFormatSnackBar,
        showInfoSnackBar,
        showErrorSnackBar,
        showSuccessSnackBar,

        snackBarOpen,
        setSnackBarOpen,

        snackBarMessage,
        setSnackBarMessage,

        snackbarAlertSeverity,
        handleSnackbarAlertSeverityChange,
      }}
    >
      {children}
    </SnackBarContext.Provider>
  );
};

export { SnackBarContextProvider, SnackBarContextConsumer, SnackBarContext };
